import Glide from '@glidejs/glide';

const startAt = 0

if (document.querySelectorAll('.featured-glide .article-block').length > 0) {
    new Glide('.featured-glide', {
        type: 'carousel',
        startAt: startAt,
        focusAt: 'center',
        perView: 3,
        breakpoints: {
            1024: {
                perView: 1
            }
        }
    }).mount()
}

if (document.querySelectorAll('.featured_articles-block .glide__bullet').length) {
    document.getElementById(`slideBullet-${startAt}`).classList.add('active')

    document.querySelectorAll('.featured_articles-block .glide__bullet').forEach(item => {
        item.addEventListener('click', () => {
            document.querySelectorAll('.featured_articles-block .glide__bullet').forEach(bullet => {
                bullet.classList.remove('active')
            });
            slider.go(`=${item.id.split('-')[1]}`)
            item.classList.add('active')
        })
    })

    slider.on('run.after', () => {
        var activeElement = document.querySelector('.featured_articles-block .glide__slide--active')
        var activeId = activeElement.id.split('-')[1]
    
        document.querySelectorAll('.featured_articles-block .glide__bullet').forEach(bullet => {
            bullet.classList.remove('active')
        });
    
        document.getElementById(`slideBullet-${activeId}`).classList.add('active')
    })
}
